import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

const V2_API_BASE = 'https://v2.infopublisher.in';

export const TimetableApi = createApi({
  reducerPath: 'TimetableApi',
  baseQuery: fetchBaseQuery({
    baseUrl: V2_API_BASE,
  }),
  endpoints: (builder) => ({
    getTeacherTimetable: builder.query({
      query: (token) => ({
        url: '/teacher/timetable',
        method: 'GET',
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }),
      transformResponse: (response) => response,
    }),
  }),
});

export const { useLazyGetTeacherTimetableQuery } = TimetableApi;

export const { TimetableApiReducer } = TimetableApi.reducer;
